var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 84V78H97.3149C98.2449 78 99.1074 77.58 99.6799 76.845C100.252 76.1125 100.45 75.175 100.225 74.2725L94.2249 50.275C93.8899 48.9375 92.6949 48.0025 91.3149 48.0025H20.9999C20.1974 48 19.4449 48.3125 18.8774 48.8775C18.3099 49.445 17.9999 50.1975 17.9999 51V75C17.9999 76.655 19.3449 78 20.9999 78H30.0024V84.0025H20.9999C16.0374 84 12.0024 79.9625 12.0024 75V51C12.0024 48.595 12.9399 46.335 14.6374 44.635C16.3374 42.935 18.5974 42 21.0024 42H91.3174C95.4549 42.0025 99.0449 44.8075 100.047 48.82L106.047 72.8175C106.725 75.525 106.127 78.3375 104.41 80.5375C102.692 82.7375 100.107 84 97.3174 84H89.9999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.475 69H87C82.0375 69 78 64.9625 78 60C78 55.0375 82.0375 51 87 51H97.8725V57H87C85.345 57 84 58.345 84 60C84 61.655 85.345 63 87 63H101.475V69Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86.9976H15V92.9976H30V86.9976Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 86.9976H90V92.9976H105V86.9976Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9999 40.755C55.4624 40.755 53.9274 40.17 52.7574 39L44.9999 31.2425C43.8674 30.11 43.2424 28.6025 43.2424 27C43.2424 25.3975 43.8674 23.89 44.9999 22.7575L52.7574 15C55.0974 12.66 58.9024 12.66 61.2424 15L68.9999 22.7575C70.1324 23.89 70.7574 25.3975 70.7574 27C70.7574 28.6025 70.1324 30.11 68.9999 31.2425L61.2424 39C60.0724 40.17 58.5349 40.755 56.9999 40.755ZM56.9974 19.24L49.2424 27L56.9999 34.7575L64.7574 27L56.9999 19.2425L56.9974 19.24Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 97.5C40.71 97.5 36 92.79 36 87C36 81.21 40.71 76.5 46.5 76.5C52.29 76.5 57 81.21 57 87C57 92.79 52.29 97.5 46.5 97.5ZM46.5 82.5C44.02 82.5 42 84.5175 42 87C42 89.4825 44.02 91.5 46.5 91.5C48.98 91.5 51 89.4825 51 87C51 84.5175 48.98 82.5 46.5 82.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 97.5C67.71 97.5 63 92.79 63 87C63 81.21 67.71 76.5 73.5 76.5C79.29 76.5 84 81.21 84 87C84 92.79 79.29 97.5 73.5 97.5ZM73.5 82.5C71.02 82.5 69 84.5175 69 87C69 89.4825 71.02 91.5 73.5 91.5C75.98 91.5 78 89.4825 78 87C78 84.5175 75.98 82.5 73.5 82.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicTransportation);
export default __webpack_public_path__ + "static/media/PublicTransportation.f8247a4d.svg";
export { ForwardRef as ReactComponent };